// extracted by mini-css-extract-plugin
export default {"fadeMask":"HorizontalScrollWithArrows_fadeMask__8HhGO","left":"HorizontalScrollWithArrows_left__A0sgk","right":"HorizontalScrollWithArrows_right__cDU4i"};